import { FaArrowRight } from "react-icons/fa6";
import { Link } from "react-router-dom";
import classes from "./Section2.module.css";

const VIDEO_ID = "Fjo3iBpMMh8";

export default function Section2() {
  return (
    <section className={classes.section}>
      <span className={classes.blobBlue} aria-hidden="true" data-parallax="0.14" />
      <span className={classes.blobTeal} aria-hidden="true" data-parallax="-0.1" />

      <div className={`container ${classes.shell}`}>
        <div className={classes.mediaCol}>
          <div className={classes.mediaWrap}>
            <span className={classes.frameGlow} aria-hidden="true" />
            <div className={classes.videoCard}>
              <iframe
                className={classes.videoFrame}
                src={`https://www.youtube.com/embed/${VIDEO_ID}`}
                title="MITSI Neurofeedback video"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          </div>
        </div>

        <div className={classes.contentCol}>
          <h2 className={classes.heading}>
            Why <span className={classes.highlight}>MITSI Neurofeedback?</span>
          </h2>

          <p className={classes.paragraph}>
            It&apos;s a medical billing program. The best part? It&apos;s mostly
            covered by superior insurance, including Medicaid and Medicare.
            MITSI kits include all costs, technician fees, equipment, billing,
            and supplies. The client&apos;s NPI handles billing and receiving
            reimbursements directly. Billing occurs monthly per kit or session.
            Clients only pay for reimbursed sessions. Kit costs are always lower
            than reimbursements, ensuring a profit.
          </p>

          <Link
            to="/contact-us"
            className="btn"
          >
            Discover More
            <FaArrowRight />
          </Link>
        </div>
      </div>
    </section>
  );
}
